<template>
  <main class="main">
    <div class="container-fluid">
      <div class="flex-row align-items-center">
        <b-row class="justify-content-center">
          <b-col class="header-col" cols="12">
              <img class="p-4 logo" src="img/sap-logo.jpg" style="max-width: 350px;" alt="SAP Logo">
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col class="header-col" cols="12">
              <h2>Registration Validity</h2>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col sm="12">
          <b-card v-if="isPlateFound">
            <div v-if="plateLoaded" slot="header">
                <strong>Plate Details</strong>
            </div>
            <div v-if="!plateLoaded" slot="header" class="text-success">
                <strong>Check plate Validity...</strong>
            </div>
            <div v-if="!plateLoaded" class="form-container">
                <LoadingSpinner />
            </div>
            <div v-if="plateLoaded" class="form-container">
              <b-row class="justify-content-center">   
                <b-col cols="12" sm="12" class="icon-display">
                  <div class="icon-container">
                    <i v-if="isPlateValid" :class="getActiveStatusClass()" class="fa fa-check font3rem"></i>
                    <div v-if="isPlateValid" class="h5 mb-0" :class="getActiveStatusClass()">VALID</div>

                    <i v-if="!isPlateValid" :class="getActiveStatusClass()" class="fa fa-exclamation-circle font3rem"></i>
                    <div v-if="!isPlateValid" class="h5 mb-0" :class="getActiveStatusClass()">INVALID</div>
                  </div>
                </b-col>
              </b-row>
              <b-row>   
                <b-col cols="12" sm="12">
                  <b-card :no-body="true" footer-class="px-3 py-2">
                    <b-card-body class="p-3 clearfix">
                      <div class="pb-3">
                        <div class="text-muted text-uppercase font-xs">Registration:</div>
                        <div class="text-uppercase font-weight-bold font-xs">{{regNumber}}</div>
                      </div>
                      <div class="pb-3">                        
                        <div class="text-muted text-uppercase font-s">Print date:</div>
                        <div class="text-uppercase font-weight-bold font-s">{{printedDate}}</div>
                      </div>
                      <div v-if="!isPageLocked">
                        <b-form-group>
                          <div class="text-muted text-uppercase font-s">Is Valid:</div>
                          <c-switch
                            id="validityToggle"
                            name="validityToggle"
                            color="success"
                            v-model="isRegNumberValid"                            
                            label
                            value="1"
                            uncheckedValue="0"
                            data-on="Yes"
                            data-off="No"
                          />
                        </b-form-group>
                      </div>
                      <div v-if="!isPageLocked" class="pb-3">                        
                        <hr />
                        <b-button variant="success" @click="togglePlateValidation()"><i class="fa fa-floppy-o"></i>&nbsp;Save</b-button>
                      </div>
                      <b-alert 
                        :show="dismissCountDown" 
                        variant="success"
                        fade
                        @dismiss-count-down="countDownChanged"
                      >
                        <h4 class="alert-heading">Status saved</h4>
                        <p>
                          The validity of the registration has been successfully updated.
                        </p>
                      </b-alert>
                    </b-card-body>
                    <div slot="footer">
                      <b-button v-if="!isPageLocked" variant="primary" @click="togglePageLock()"><i class="fa fa-unlock"></i>&nbsp;Lock</b-button>
                      <b-form-group v-if="isPageLocked">
                        <b-input-group>
                          <b-form-input type="password" placeholder="Enter PIN" v-model="pagePIN"></b-form-input>                         
                          <b-input-group-append>
                            <b-button variant="primary" @click="togglePageLock()"><i class="fa fa-unlock"></i>&nbsp;Unlock</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-card>
          <b-card v-if="!isPlateFound">
            <div v-if="plateLoaded" slot="header">
                <strong>Plate Details</strong>
            </div>
            <div v-if="plateLoaded" class="form-container">
              <b-row class="justify-content-center">   
                <b-col cols="12" sm="12" class="icon-display">
                  <div class="icon-container">
                    <i class="fa fa-exclamation-circle font3rem invalid"></i>
                    <div class="h5 mb-0 invalid">PLATE NOT FOUND</div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import CryptoJS from 'vue-cryptojs';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment';

const getHTTPHeaders = () => {
  let userObj = JSON.parse(localStorage.getItem('user'));
  let headerConfig = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  }
  return headerConfig;
}

const getEncryptionSettings = (($http) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.get("getEncryptionPhrases", headersObj)
      .then((response) => {
        resolve(response.data);
      })
      .catch ((err) => {
        console.error(err);
        reject(err);
      });
  });
});

const getRegDetail = (($http, regValue) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.get("plates/validate/search?vrm=" + regValue, headersObj)
      .then((response) => {
        resolve(response.data);
      })
      .catch ((err) => {
        console.error(err);
        reject(err);
      });
  });
});

const updateRegValidation = (($http, regValue) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.post("plates/validate/update", {'vrm': regValue}, headersObj)
      .then((response) => {
        resolve(response.data);
      })
      .catch ((err) => {
        console.error(err);
        reject(err);
      });
  });
});

export default {

  name: 'regvalidate',
  components: {
    LoadingSpinner: LoadingSpinner,
    cSwitch
  },
  data: function () {
    return {
      noRegFound: false,
      routeKey: '',
      regFetchInProgress: false,
      plateLoaded: false,
      decryptPhrase: '',
      regNumber: '', 
      isRegNumberValid: 0,
      printedDate: '',
      isPageLocked: true,
      pagePIN: '',
      isPlateFound: true,
      dismissSecs: 4,
      dismissCountDown: 0,
    }
  },
  created() {
    this.$data.routeKey = this.$route.params.key;
    console.log('key = ', this.$data.routeKey);
    this.getEncryptedRegNumber();
  },
  computed: {
    isPlateValid() {
      if (this.$data.isRegNumberValid == '0') {
        return false;
      }
      else {
        return true;
      }
    }
  },
  methods: {
    getEncryptedRegNumber() {
      getEncryptionSettings(this.$http)
      .then((data) => {
        console.log('key = ', this.$data.routeKey);
        console.log('encrypt data = ', data);
        this.$data.decryptPhrase = data.encryption[0].decrypt_secret_phrase;
        this.decryptKey();
      });
    },
    decryptKey() {
      const regDecrypted = this.$CryptoJS.AES.decrypt(this.$data.routeKey, this.$data.decryptPhrase).toString(this.$CryptoJS.enc.Latin1);
      console.log(regDecrypted);
      getRegDetail(this.$http, regDecrypted)
        .then((data) => {
          try {
            this.$data.regNumber = data.validatedPlate[0].reg_number;
            this.$data.isRegNumberValid = data.validatedPlate[0].is_reg_number_valid;
            this.$data.printedDate = moment(data.validatedPlate[0].printed_date).format("LL");
            this.$data.plateLoaded = true;
            console.log(this.$data.isRegNumberValid);
            this.$data.isPlateFound = true;
          }
          catch (err) {
            this.$data.regNumber = '';
            this.$data.isRegNumberValid = '0';
            this.$data.printedDate = '';
            this.$data.plateLoaded = true;
            this.$data.isPlateFound = false;
          }
        });
    },
    getActiveStatusClass() {
      return this.$data.isRegNumberValid == '0' ? 'invalid' : 'validated';
    },
    togglePageLock() {
      console.log(this.$data.isPageLocked);
      if (!this.$data.isPageLocked) {
        this.$data.pagePIN = '';
        this.$data.isPageLocked = true;
      }
      else {
        if (this.$data.pagePIN == '1234') {
          this.$data.isPageLocked = false;     
        }
        else {
          this.$data.isPageLocked = true;
        }
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      this.togglePageLock();
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    togglePlateValidation() {
      // make the call to the API
      updateRegValidation(this.$http, this.$data.regNumber)
      .then((data) => {
        this.showAlert();
        console.log(data);
      })
    },
    getValidityToggleButtonVariant() {
      return this.$data.isRegNumberValid == '0' ? 'outline-danger' : 'outline-success';
    }
  }
}
</script>

<style scoped>

  .header-col {
    display: contents;
  }
  .header-col h2 {
    display: inline-block;
    padding: 0.5em;
  }
  .validated {
    color: #4dbd74!important;
  }
  .invalid {
      color: #f86c6b!important;
  }
  .font3rem {
    font-size: 3rem !important;
    padding: 1rem !important;
    padding-left: 0 !important;
  }
  .icon-display {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .icon-container {
    align-items: center;
    display: flex;
  }
  img.logo {
    max-width: 350px;
    align-self: auto;
  }
</style>
